<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'DictSelect',
})
</script>
<template>
  <Select optionFilterProp="label" optionLabelProp="label" placeholder="请选择" show-search allowClear :options="options" v-bind="$attrs" />
</template>
<script lang="ts" setup name="DictSelect">
import { useDictStore } from '@/store/modules/dict'
import { Select } from 'ant-design-vue'
import { computed } from 'vue'
const props = defineProps<{
  type: string
}>()
const dictStore = useDictStore()
const options = computed(() => dictStore.category.get(props.type) || [])
</script>
